import { Box } from '@mui/material'

import { GachaRollType, Maybe } from '@/clients/utoniq-core/schema'
import { PointDisplayPurchase, Purchase } from '@/components/organisms'
import { config } from '@/config'
import { Cell } from '@/core/architecture'

type Props = {
  /** ガチャが利用可能かどうか */
  available: boolean
  /** ガチャ種別 */
  type: Maybe<GachaRollType> | undefined
  /** ユーザーが所持しているポイント数 */
  point: string | number
  /** ポイントをタップした時の挙動 */
  onClickPoint: () => void
  /** ユーザーが所持しているガチャチケット */
  ticket: string | number
  /** ガチャチケットをタップした時の挙動 */
  onClickGachaTicket: () => void
  /** ガチャチケットが購入可能か */
  isGachaTicketPurchasable: boolean
  /** ガチャチケットのサムネイル画像 */
  gachaTicketThumbnail: string
}

/**
 * @description
 * ガチャ詳細ヘッダー右部に表示するポイント・ガチャチケットの購入ボタン
 * ガチャの種別によってポイント・ガチャチケットのアイコンと所持数を表示する
 *
 */

export const HeaderPurchase: Cell<Props> = ({
  available,
  type,
  point,
  onClickPoint,
  ticket,
  onClickGachaTicket,
  isGachaTicketPurchasable,
  gachaTicketThumbnail,
}) => {
  // ユーザー又はガチャが利用できない場合、何も返さない
  if (!available) return null

  // ポイントで買えるガチャの場合、ポイント用UIを表示
  if (type === GachaRollType.PrepaidPoint && config.modules.prepaidPoint)
    return <PurchasePoint onClick={onClickPoint} point={point} />

  // ガチャチケット用UIを表示
  return (
    <PurchaseGachaTicket
      ticket={ticket}
      gachaTicketThumbnail={gachaTicketThumbnail}
      isPurchasable={
        isGachaTicketPurchasable && !!config.modules.prepaidPoint?.chargeable
      }
      onClick={onClickGachaTicket}
    />
  )
}

const PurchasePoint: Cell<{
  point: string | number
  onClick: () => void
}> = ({ onClick, point }) => {
  return <PointDisplayPurchase onClick={onClick} point={point} />
}

const PurchaseGachaTicket: Cell<{
  ticket: string | number
  isPurchasable: boolean
  gachaTicketThumbnail: string
  onClick: () => void
}> = ({ ticket, onClick, isPurchasable, gachaTicketThumbnail }) => {
  return (
    <Box sx={{ mr: -2, ml: '10px' }}>
      <Purchase
        ticket={ticket}
        isPurchasable={isPurchasable}
        src={gachaTicketThumbnail}
        onPurchase={onClick}
      />
    </Box>
  )
}
